'use client';
import React from 'react';

import ListPage from '../../../../../components/page-components/list-page/list-page';
import {
  createListCardArray,
  mergeTenantListItems,
} from '../../../../../helpers/list-page/list-page-helpers';
import { pageIsTenantShop } from '../../../../../helpers/list-page/type-guards';
import useGetMobileAppWebViewHeader from '../../../../../hooks/use-get-mobile-app-web-view';
import { IMeetingplacePageHomeMinifiedExtendedAttributeFilters } from '../../../../../lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageTenantList } from '../../../../../lib/fragments/meetingPlacePageTenantList';
import { IMeetingPlacePageTenantShopList } from '../../../../../lib/fragments/meetingPlacePageTenantShopList';
import {
  useGetActiveEvents,
  useGetActiveOffers,
  useTenantConfig,
} from '@/providers/ConfigProvider';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';
// import { PageContext } from '../../../../page-context.interface';

interface MeetingPlacePageTenantShopListProps {
  metaData: any;
  node_locale: string;
  urlSubdirectory?: string;
  tenantListId?: string;
  shopListData: {
    meetingPlacePageTenantShopList: IMeetingPlacePageTenantShopList | null;
    meetingPlacePageTenantList: IMeetingPlacePageTenantList | null;
    meetingPlacePageHomeCollection: IMeetingplacePageHomeMinifiedExtendedAttributeFilters | null;
  };
  initialPage?: number;
}
const MeetingPlacePageTenantShopList = ({
  metaData,
  node_locale,
  urlSubdirectory,
  tenantListId,
  shopListData,
  initialPage,
}: MeetingPlacePageTenantShopListProps) => {
  const config = useTenantConfig();
  const activeOffers = useGetActiveOffers();
  const activeEvents = useGetActiveEvents();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';

  const page = shopListData?.meetingPlacePageTenantShopList;
  const homepage = shopListData?.meetingPlacePageHomeCollection;

  let shopPages = mergeTenantListItems(
    shopListData?.meetingPlacePageTenantList?.tenantsCollection?.items,
    page?.shopItemsCollection?.items,
    pageIsTenantShop,
  );

  shopPages = shopPages?.filter(Boolean)?.map((item) => {
    const hasOffer = activeOffers?.find(
      (offer: any) => offer?.tenant?.sys?.id == item?.sys?.id,
    );
    const offerCampaignNames = [
      ...new Set(
        activeOffers
          ?.filter((offer: any) => offer?.tenant?.sys?.id == item?.sys?.id)
          .flatMap((o: any) => o?.tags ?? [])
          .filter(Boolean),
      ),
    ] as string[];
    return {
      ...item,
      hasOffer: hasOffer ? true : false,
      ...(offerCampaignNames.length > 0 && { offerCampaignNames }),
    };
  });

  shopPages = shopPages?.filter(Boolean)?.map((item) => {
    const hasEvent = activeEvents?.find(
      (event: any) => event?.tenant?.sys?.id == item?.sys?.id,
    );
    return {
      ...item,
      hasEvent: hasEvent ? true : false,
    };
  });

  const shopCardList = createListCardArray(
    shopPages,
    undefined,
    undefined,
    urlSubdirectory,
    node_locale || page?.sys?.locale,
    prefix,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {page && (
        <>
          {/* ✅ GTM PAGE VIEW */}
          <GtmPageView
            homepage={homepage}
            language={node_locale}
            pageTitle={page?.name ?? ''}
          />

          <ListPage
            cardList={shopCardList}
            pageName={page?.name}
            pageSlug={page?.slug}
            node_locale={node_locale}
            // location={location}
            breadcrumbs={[page?.name]}
            homeText={homepage?.breadcrumbHomeText ?? ''}
            tileColClass="grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
            listType="shop"
            attributeFilters={homepage?.meetingPlace.attributeFilters}
            isWebView={isWebView}
            // pageContext={pageContext}
            businessUnitCode={homepage?.meetingPlace?.businessUnitCode}
            config={config}
            initialPage={initialPage ?? 1}
          />
        </>
      )}
    </>
  );
};

export default MeetingPlacePageTenantShopList;

